export const RedirectProtocol = 'app-fb52e143-casino://';

export enum RedirectChannel {
  NativeApp = 'nativeapp',
  Web = 'web',
}

export enum CampaignType {
  Absolute = 'absolute',
  Service = 'service',
  Error = 'error',
  GameEvent = 'game_event',
  Sport = 'sport',
  Category = 'category',
  Championship = 'championship',
  Outcome = 'outcome',
  BonusRegistration = 'bonus_registration',
  ProfileStatus = 'profile_status',
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
  Main = 'main',
  Live = 'live',
  Prematch = 'prematch',
  Support = 'support',
  Campaigner = 'campaigner',
  Rewards = 'rewards',
  AccountVerification = 'account_verification',
  Registration = 'registration',
  PasswordRestore = 'password_restore',
  Profile = 'profile',
  PersonalData = 'personal_data',
  WithdrawalHistory = 'withdrawal_history',
  Betgames = 'betgames',
  Tvbet = 'tvbet',
  VirtualSports = 'virtual_sports',
  Casino = 'casino',
  LiveCasino = 'live_casino',
  Slots = 'slots',
  Toto = 'toto',
  Promo = 'promo',
  Footboss = 'footboss',
  Content = 'content',
}

export type RedirectCampaignType = Exclude<CampaignType, CampaignType.Absolute | CampaignType.Service>;
